import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import * as actionCreators from '../../../_store/actions/index';

import styles from './Blur.scss';

class Blur extends Component {
	componentDidMount = () => {
		this.props.onHelpersBlurAppend();
	}
    componentWillUnmount = () => {
    	this.props.onHelpersBlurRemove();
    }
	render() {
		let classNames = styles.a_blur
		if(this.props.theme == 'light'){
			classNames = classNames + ' ' + styles.isLight
		}

	    return (
			<div className={classNames}><div className={styles.background} onClick={this.props.clicked}></div>{this.props.children}</div>
		)
	}
}

const mapDispatchToProps = dispatch => {
    return {
        onHelpersBlurAppend: () => dispatch(actionCreators.helpersBlurAppend()),
        onHelpersBlurRemove: () => dispatch(actionCreators.helpersBlurRemove()),
    }
};
export default connect(null,mapDispatchToProps)(Blur);



// WEBPACK FOOTER //
// ./src/components/molecules/Blur/index.js